import Card from "app/components/Card";
import IconButton from "app/components/IconButton";
import Input from "app/components/Input";
import {
  selectTicketCreateLoading,
  selectTicketFormDetail,
} from "app/containers/Features/containers/Boards/containers/Tickets/redux/selector";
import { selectTicketTypes, selectUserFormData } from "app/redux/selector";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { ITicketFormData, TicketGroup } from "../../containers/Tickets/types";
import { useTicketCreateActions } from "../../containers/Tickets/useTicketCreateActions";
import { attachClickOutsideListener } from "../Settings/helper";
import { useBoardsActions } from "../useBoardsActions";
import Fields from "./fields";
interface ColumnTaskCreateProps {
  readonly group: TicketGroup;
}

const ColumnTaskCreate: React.FC<ColumnTaskCreateProps> = ({ group }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const params = useParams();
  const ticketTypes = useSelector(selectTicketTypes);
  const dispatch = useDispatch();
  const form = useSelector(selectTicketFormDetail);
  const loading = useSelector(selectTicketCreateLoading);
  const currentUser = useSelector(selectUserFormData)
  const { fetchBoardsGroupsJson } = useBoardsActions(params.project as string);
  const { setTicketField } = useTicketCreateActions();

  const onCancel = () => {
    dispatch(ticketGroupsActions.clearCreateTicket());
    dispatch(
      ticketGroupsActions.toggleCreateTicketIntoGroup({
        groupId: "",
        actions: false,
      }),
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setTicketField("title", value);
  };
  const handleSelect = (name: string, value: any) => {
    setTicketField(name as keyof ITicketFormData, value);
  };

  const handleSave = () => {
    dispatch(
      ticketGroupsActions.setCreateTicket({
        projectId: currentUser.selectedProjectId as string,
        boardId: params.boardId as string,
        groupId: group?._id,
        callback() {
          fetchBoardsGroupsJson(params.boardId as string);
        },
      }),
    );
  };
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  React.useEffect(() => {
    const cleanup = attachClickOutsideListener(ref, () => {
      if (isDropdownOpen) {
        setIsDropdownOpen(false);
        return;
      }

      if (!form?.title || form?.title.length === 0) {
        onCancel();
      }
    });

    return cleanup;
  }, [form?.title, isDropdownOpen]);
  const handleInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSave();
      } else if (e.key === "Escape") {
        onCancel();
      }
    },
    [handleSave, onCancel],
  );

  return (
    <React.Fragment>
      <Card
        ref={ref}
        className={`cursor-pointer hover:border border-secondary relative rounded-[6px] ps-[10px] pr-[8px] py-[12px]    `}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-row gap-[4px] group relative items-center justify-between">
            <div className="flex items-center gap-[4px] ">
              <div className="w-[85%] ">
                <Input
                  type="text"
                  id="title"
                  name="title"
                  value={form?.title}
                  onChange={(e) => handleChange(e)}
                  className="w-full text-sm leading-[21px] font-medium focus:outline-none"
                  inputClassName="!h-[20px] px-[6px]"
                  placeholder={`Enter ${ticketTypes
                    ?.find((x) => x?._id === form?.type)
                    ?.name?.toLowerCase()} name`}
                  autoFocus
                  noBorder
                  onKeyDown={(e) => {
                    if (form?.title) {
                      handleInputKeyDown(e);
                    }
                  }}
                  disabled={loading}
                />
              </div>
            </div>
            {form?.title?.length > 0 && (
              <IconButton
                className="border-0"
                onClick={() => handleSave()}
                loading={loading}
              />
            )}
          </div>
          <Fields
            onOpen={() => setIsDropdownOpen(true)}
            onClose={() => setIsDropdownOpen(false)}
            form={form}
            handleSelect={handleSelect}
            group={group}
            projectId={params.project as string}
          />
        </div>
      </Card>
    </React.Fragment>
  );
};

export default ColumnTaskCreate;
